export default __webpack_public_path__ + "static/media/pinwheel.232c79f6.gif";